import axios from 'axios';

const API_KEY = process.env.REACT_APP_PORTFOLIO_API_KEY;
const BASE_URL = `https://uswagon.mapple.online/api/ext/v1/uswportolios/${API_KEY}`;

const client = axios.create({ baseURL: BASE_URL });

function unwrap(response) {
  const body = response?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

export async function getProjectList() {
  const res = await client.get('/data/project-list');
  const data = unwrap(res);
  return Array.isArray(data) ? data : [];
}

export async function getProject(id) {
  const res = await client.get(`/data/project-list/${id}`);
  return unwrap(res);
}

export async function getProjectFeatures(id) {
  const res = await client.get('/data/project-features', {
    params: { 'filter[473]': id },
  });
  const data = unwrap(res);
  return Array.isArray(data) ? data : [];
}

export async function getProjectGallery(id) {
  const res = await client.get('/data/project-gallery', {
    params: { 'filter[478]': id },
  });
  const data = unwrap(res);
  return Array.isArray(data) ? data : [];
}

export async function getProjectActions(id) {
  const res = await client.get('/data/project-actions', {
    params: { 'filter[475]': id },
  });
  const data = unwrap(res);
  return Array.isArray(data) ? data : [];
}
